
import api from '@/api';

const namespaced = true;

const state = {
};

const mutations = {
};

const actions = {
  async fetchForIntervention(noop, interventionId) {
    const { data: files } = await api.get(`/files/intervention/${interventionId}`);
    return files;
  },
  async addFile(noop, {
    type, interventionId, filename, mimeType, content, description,
  }) {
    const { data: file } = await api.post(`/files/intervention/${interventionId}`, {
      description,
      filename,
      type,
      mimeType,
      content,
    });

    return file;
  },
  delete(noop, fileId) {
    return api.delete(`/files/${fileId}`);
  },
};

const getters = {
};

export default {
  namespaced, state, mutations, actions, getters,
};
